module.exports = __webpack_public_path__ + "media/images/athletes/1903-a68a1c529dbe79032bc08db6b95cbbdc.png";